import { render } from "./Recoleccion_Detalle.vue?vue&type=template&id=2819d27c"
import script from "./Recoleccion_Detalle.vue?vue&type=script&lang=js"
export * from "./Recoleccion_Detalle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__